import FakeLoginButton from './FakeLoginButton';
import {DEBUGMODE, LOGIN_URL} from '../utils/constants';
import {UaButton} from 'uppsala.ui.react';

interface LoginButtonProps {
  readonly title: string;
  readonly disabled?: boolean;
  readonly returnUrl?: string;
}

export default function LoginButton(props: LoginButtonProps) {
  const handleLogin = () => {
    const returnUrl = props.returnUrl ? `${window.location.origin}${props.returnUrl}` : window.location.href;
    const url = `${LOGIN_URL}?returnUrl=${returnUrl}`;
    if (!url) throw new Error('LOGIN_URL was undefined');
    window.location.href = url;
  };

  return (
    <>
      <UaButton className='mb-3' disabled={props.disabled} type="primary" title={props.title} onClick={handleLogin} />
      {DEBUGMODE && <FakeLoginButton disabled={props.disabled} returnUrl={props.returnUrl} />}
    </>
  );
}
